// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"90d2598d","455":"34fec8a7","593":"8120c84f","748":"9ed72d5f"}[chunkId] + ".chunk.js";
};